import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useGlobals, useUserContext } from '@/hooks';

const ProtectedRoute = ({ element, requiredAccess }: any) => {
  const { isSignedIn } = useUserContext();
  const { canAccessCheckout, canAccessSuccess, setCanAccessCheckout } = useGlobals();

  useEffect(() => {
    if (requiredAccess !== 'checkout' && canAccessCheckout) {
      setCanAccessCheckout(false);
    }
  }, [requiredAccess, canAccessCheckout, setCanAccessCheckout]);

  if (!isSignedIn) {
    return <Navigate to="/login" />;
  }

  if (requiredAccess === 'checkout' && !canAccessCheckout) {
    return <Navigate to="/carrinho" replace />;
  }

  if (requiredAccess === 'success' && !canAccessSuccess) {
    return <Navigate to="/checkout" replace />;
  }

  return element;
};

export default ProtectedRoute;
